/**
 * Limits that are not the chat's (ADR 0040): a bucket of tokens for every
 * message a session sends, and a count of its faults over a sliding window.
 * Pure and clock-injected, like `ChatRateLimiter`, so the room and the tests
 * share one definition of « too much ».
 */
export class TokenBucket {
    burst;
    refillPerMs;
    tokens;
    lastAt;
    constructor(now, options) {
        this.burst = options.burst;
        this.refillPerMs = options.perSecond / 1000;
        this.tokens = options.burst;
        this.lastAt = now;
    }
    tryConsume(now) {
        const elapsed = Math.max(0, now - this.lastAt);
        this.tokens = Math.min(this.burst, this.tokens + elapsed * this.refillPerMs);
        this.lastAt = now;
        if (this.tokens >= 1) {
            this.tokens -= 1;
            return { allowed: true, retryInMs: 0 };
        }
        return { allowed: false, retryInMs: Math.ceil((1 - this.tokens) / this.refillPerMs) };
    }
}
/**
 * Every message of a session, whatever its type. An honest client sends a
 * few a second (a click, a spell); a script that floods hits this within a
 * second and each message past it is a fault.
 */
export const WS_MESSAGE_BURST = 60;
export const WS_MESSAGE_PER_SECOND = 25;
/** Faults are remembered this long. */
export const STRIKE_WINDOW_MS = 60_000;
/** This many faults in the window close the session (`CLOSE_CODE_FLOOD`). */
export const KICK_AT_STRIKES = 20;
export class StrikeCounter {
    windowMs;
    at = [];
    constructor(windowMs = STRIKE_WINDOW_MS) {
        this.windowMs = windowMs;
    }
    /** Record a fault; returns how many stand in the window, this one included. */
    strike(now) {
        this.at.push(now);
        return this.count(now);
    }
    count(now) {
        while (this.at.length > 0 && now - (this.at[0] ?? now) >= this.windowMs)
            this.at.shift();
        return this.at.length;
    }
}
//# sourceMappingURL=rate-limit.js.map